import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { connect } from '../../../common/react-redux';
import { updateBank } from '../../api/banks';
import EditBankModal from './presenter';
import * as modalActions from '../../../common/actions/modal';
import { EDIT_BANK_MODAL } from '@instructure/quiz-common';
import { changeBank, clearModifications } from '../../../common/actions/modifications';
import { showError, hideError } from '../../../common/actions/errorsShowing';
import { getModalTrigger } from '../../../common/util/modalHelpers';
function mapStateToProps(state, props) {
  var errorsMap = state.get('errorsShowing', Map());
  var errorKey = "".concat(props.workingBank.id, "_edit_bank");
  return {
    modalOpen: state.getIn(['modal', 'isOpen']) === [EDIT_BANK_MODAL, props.workingBank.id].join(':'),
    modalTrigger: getModalTrigger(state),
    errorKey: errorKey,
    displayError: errorsMap.get(errorKey)
  };
}
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateBank: bindActionCreators(updateBank, dispatch),
    changeBank: bindActionCreators(changeBank, dispatch),
    clearModifications: bindActionCreators(clearModifications, dispatch),
    showError: bindActionCreators(showError, dispatch),
    hideError: bindActionCreators(hideError, dispatch),
    closeModal: bindActionCreators(modalActions.closeModal, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EditBankModal);